import React, { FC, useEffect } from "react";
import { Link as RrdLink, LinkProps } from "react-router-dom";

interface Props extends Omit<LinkProps, "to"> {
  href: any;
}


const Link: FC<Props> = ({ href, ...args }) => {
  const scrollToSection = (section : any) => {
    const element = document.getElementById(section);
    if(section){
      element?.scrollIntoView({ behavior: 'smooth', block:'center'});
    return
    }
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  };

  return <RrdLink {...args} to={href} onClick={()=>scrollToSection(href.hash)}/>;
};

export default Link;
